// «جوابِ من به این دعوت» در قالبِ متن.
//
// از فاز ۴ اینجاست. قبلاً داخلِ RespondSheet.tsx اپ موبایل بود — یعنی منطقِ
// خالصِ «کدام جواب چه برچسبی دارد» به یک کامپوننتِ react-native چسبیده بود و
// سایت راهی برای رسیدن بهش نداشت جز کپی کردن.
import { t } from './i18n.ts';
import type { Signal } from '../domain/types.ts';

/**
 * جوابِ من در یک‌دو کلمه، برای کارتِ فشرده‌ی فهرست.
 *
 * `answerLabel` جمله‌ی کاملِ صفحه‌ی سیگناله («تو گفتی این‌جور کارها به تو
 * نمی‌خوره»). توی کارتِ فشرده اون جمله دو خط می‌شد و بقیه‌ی کارت رو هل می‌داد.
 */
export function answerShort(signal: Signal): string {
  if (!signal.myResponse || signal.myResponse === 'pending') return t('tapToAnswer');
  if (signal.myResponse === 'in') return t('shortIn');
  if (signal.myResponse === 'maybe') return t('shortMaybe');
  if (signal.myResponse === 'conditional') return t('shortConditional');
  return signal.myDeclineReason === 'not_my_thing' ? t('shortNotMyThing') : t('shortOut');
}

export function answerLabel(signal: Signal): string {
  if (!signal.myResponse || signal.myResponse === 'pending') return t('noAnswerYet');
  if (signal.myResponse === 'in') return t('ansIn');
  if (signal.myResponse === 'maybe') return t('ansMaybe');
  if (signal.myResponse === 'conditional') {
    return `${t('ansCondPrefix')}${signal.myCondition?.label ?? ''}`;
  }
  return signal.myDeclineReason === 'not_my_thing' ? t('ansNotMyThing') : t('ansOut');
}
